import { operationOutcomeToString } from '@medplum/core'
import type { OperationOutcome } from '@medplum/fhirtypes'

export function documentUploadErrorMessage(outcome: OperationOutcome): string {
  const message = operationOutcomeToString(outcome)
  return message === 'Unknown error' ? 'Upload failed' : message
}
